<script setup lang="ts">
  defineProps<{
    trainingRequired: 'sim' | 'não';
    justification?: string | null;
  }>();
</script>

<template>
  <div class="p-6">
    <div class="flex gap-6">
      <div class="h-auto flex flex-col gap-2 w-fit shrink-0">
        <div class="font-semibold flex whitespace-nowrap">
          Será necessário treinamento?
        </div>
        <div
          class="rounded-2xl border flex items-center px-5 py-3 min-h-12 border-border-color bg-gray-02/20 text-left capitalize"
        >
          {{ trainingRequired }}
        </div>
      </div>

      <div
        v-if="trainingRequired === 'não'"
        class="h-auto flex flex-col gap-2 flex-1 min-w-0"
      >
        <div class="font-semibold flex">
          Justificativa:
        </div>
        <div
          class="rounded-2xl border flex items-center px-5 py-3 min-h-12 border-border-color bg-gray-02/20 break-all w-full"
        >
          {{ justification?.trim() || '-' }}
        </div>
      </div>
    </div>
  </div>
</template>
